export default "__VITE_ASSET__fbc4cbf0__"